export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_l1.bd6e2810.jpg";